import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      class: "item hull_1",
      src: `/img/items/hull/bo/warrior/side.png`
    }, null, -1),
    _createElementVNode("img", {
      class: "item probe_1",
      src: `/img/items/probe/3.png`
    }, null, -1),
    _createElementVNode("img", {
      class: "item droid_1",
      src: `/img/items/droid/6.png`
    }, null, -1)
  ])))
}